/**
 * Internal email send/edit failures, as `ApiAts::V1::InternalEmailsController`
 * reports them (`CREATOR_ERRORS` / `UPDATE_ERRORS`).
 *
 * Every one of these used to reach the user as the raw code in a toast, because
 * the drawer showed the thrown `Error.message` — which is the code. QA filed the
 * recipient cap as "unable to send mail due to an error response" (CORE-5377)
 * and had to read the reason out of DevTools.
 */

import {
  MAX_CC_BCC_RECIPIENTS,
  MAX_TO_RECIPIENTS,
} from '@/constants/internal-email-recipients';

const internalEmail = {
  err_internal_email_too_many_recipients: {
    // Both numbers, because they are two budgets and the sender cannot tell which
    // one they blew: To sends each person their own copy, while cc and bcc share
    // one. Naming them is the whole point of the message — "too many" without a
    // limit leaves the sender guessing how much to remove.
    message: `An internal email can reach ${MAX_TO_RECIPIENTS} people in To, and ${MAX_CC_BCC_RECIPIENTS} across CC and BCC. Remove some recipients — a role adds everyone holding it — and try again.`,
  },
  err_internal_email_no_recipients: {
    message:
      'Nobody holds the roles you picked on this job, so there is no one to send to. Choose different recipients.',
  },
  err_no_active_sender: {
    message:
      'The sender no longer has a connected mailbox. Pick someone else in the From field.',
  },
  err_internal_email_template_missing: {
    message: 'The template this email uses no longer exists.',
  },
  err_internal_email_template_incomplete: {
    message: 'The template this email uses has no subject or no body.',
  },
  err_internal_email_shared_email_invalid: {
    message: 'The shared inbox you picked is not available. Choose another.',
  },
  err_internal_email_invalid_participant_groups: {
    message:
      'One of the roles you picked is not valid on this job. Remove it and try again.',
  },
  err_internal_email_already_exists: {
    message: 'This internal email has already been created.',
  },
  err_internal_email_already_sent: {
    message:
      'This email went out while you were editing it, so it cannot be changed.',
  },
  err_internal_email_attachment_not_found: {
    message:
      'One of the attached files is no longer available. Remove it and attach it again.',
  },
  err_internal_email_invalid_reply_target: {
    message: 'The email you are replying to is no longer available.',
  },
};

export default internalEmail;
